import { render, staticRenderFns } from "./SoldInformation.vue?vue&type=template&id=13d9841e&"
import script from "./SoldInformation.vue?vue&type=script&lang=js&"
export * from "./SoldInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports